

export const restrictionController = ({restriction, client, products, deleteProduct}) => {
    if (restriction && !client?.older) {
        const removedProducts = [];

        for (const prod of products) {
            if (prod.restricted) {
                removedProducts.push(prod.name);

                deleteProduct(prod.index);
            }
        } 

        // CONTROLE DE ALERTA
        if (removedProducts.length > 0) {
            return ({status: 201, message: `Os seguintes produtos foram removidos do seu pedido: ${removedProducts.join(', ')}.\n\nMotivo: Produtos restritos para menores de 18 anos!`})
        }
    }

    return ({status: 200, message: 'OK'});
};